var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "19px",
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CCCC2AD6-5470-4DD8-9D23-30039B04C6CE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Summary-Cards",
    transform: "translate(-360.000000, -317.000000)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Property",
    transform: "translate(360.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-bed",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999475,11 C19.9998526,9.06560935 19.9996887,5 19.9999872,5 C19.9999872,5 4,5.00130377 4,4.99961498 L4,11 L6,11 L6,7.99980749 C6,7.44762906 6.44371665,7 6.99980749,7 L10.0001925,7 C10.5523709,7 11,7.44371665 11,7.99980749 L11,11 L13,11 L13,7.99980749 C13,7.44762906 13.4437166,7 13.9998075,7 L17.0001925,7 C17.5523709,7 18,7.44371665 18,7.99980749 L18,11 L19.9999475,11 Z M4,20 L4,21.0010434 C4,21.5527519 3.55613518,22 3,22 C2.44771525,22 2,21.5508697 2,21.0010434 L2,19.9999945 C0.894973065,19.9973308 0,19.1025015 0,18.0026083 L0,12.9973917 C0,11.8959049 0.894357456,11.002663 2,11.0000059 L2,4.99961498 C2,3.89525812 2.89821238,3 4.00001277,3 L19.9999872,3 C21.1045638,3 22,3.89623382 22,4.99961498 L22,11.0000055 C23.1050269,11.0026692 24,11.8974985 24,12.9973917 L24,18.0026083 C24,19.1040951 23.1056425,19.997337 22,19.9999941 L22,21.0010434 C22,21.5527519 21.5561352,22 21,22 C20.4477153,22 20,21.5508697 20,21.0010434 L20,20 L4,20 Z M2,18.0026083 C2,17.9986777 21.9950534,18 21.9950534,18 C21.9964108,18 21.9973965,17.5877799 21.9981121,17 L2.00015602,17 C2.00001801,17.5891683 2,18.0026083 2,18.0026083 Z M21.9995285,15 C21.9999591,13.9359473 22,12.9973917 22,12.9973917 C22,13.0013223 2.00494659,13 2.00494659,13 C2.00290006,13 2.00169843,13.9370223 2.0009937,15 L21.9995285,15 Z",
    id: "path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedWhite);
export default __webpack_public_path__ + "static/media/bed-white.5728ec5bda7b4cf18fe401bbd1dc1578.svg";
export { ForwardRef as ReactComponent };